module.exports = __webpack_public_path__ + "static/media/02.02c7d727.jpg";